<template>
  <v-layout align-center justify-center>
    <v-overlay v-if="loading" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-flex v-else xs12 sm8 md10>
      <v-layout align-center justify-center column>
        <v-img
          :src="require('@/assets/images/logo.png')"
          width="144px"
          height="144px"
        ></v-img>
        <div class="display-1 ma-3 font-weight-bold">Tradie Pass</div>
      </v-layout>

      <div v-if="entries.length === 0" class="text-center grey--text py-8">
        No resources published yet.
      </div>

      <v-card v-for="entry in entries" :key="entry.id" class="pa-3 mb-4">
        <v-card-title class="font-weight-bold text-break" v-if="entry.title">
          {{ entry.title }}
        </v-card-title>
        <v-card-subtitle class="pt-1">
          {{ formatDate(entry.created_at) }}
        </v-card-subtitle>
        <v-card-text>
          <div class="resource-content" v-html="entry.content" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs'

export default {
  data() {
    return {
      entries: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const { data } = await this.$api.get('resources')
        this.entries = data.data || []
      } finally {
        this.loading = false
      }
    },
    formatDate(ts) {
      return dayjs(ts).format('D MMM YYYY')
    },
  },
}
</script>

<style lang="scss" scoped>
.display-1 {
  color: #fff;
}
.text-break {
  white-space: pre-wrap;
  word-break: break-word;
}
.resource-content ::v-deep img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}
</style>
